import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import moment from 'moment';

import _t from 'i18n!nls/unified-description-page-common';

export const durationToMinutes = (duration: string) => {
  const minutes = Math.round(moment.duration(duration).asMinutes());

  return <FormattedMessage message={_t('{minutes, plural, =1 {# minute} other {# minutes}}')} minutes={minutes} />;
};

export const durationToHours = (duration: string) => {
  const hours = Math.round(moment.duration(duration).asHours());

  if (hours <= 0) {
    return durationToMinutes(duration);
  }

  return <FormattedMessage message={_t('{hours, plural, =1 {# hour} other {# hours}}')} hours={hours} />;
};
